{
  "currentEnvironment": "local",
  "gtmId": "",
  "regionalResourceCode": "",
  "formTemplatesDisabled": "false",
  "referralsDisabled": "false",
  "allowedCountriesPhoneList": "fr be de es it ba hr",
  "campaignTrackingDisabled": "false",
  "preferredCountriesPhoneList": "be fr de lu",
  "maintenanceModeActive": "false",
  "maintenanceAvailableAppPath": "d5a804c1-ec6e-4d17-841c-92c8f613caca",
  "adyenClientKey": "test_3FRFLC3AKZAGBAN3LMDAFQAVGY55DIZB",
  "adyenEnvironment": "test"
}
